import { render, staticRenderFns } from "./SfColorPicker.vue?vue&type=template&id=a01db664"
import script from "./SfColorPicker.vue?vue&type=script&lang=js"
export * from "./SfColorPicker.vue?vue&type=script&lang=js"
import style0 from "./SfColorPicker.vue?vue&type=style&index=0&id=a01db664&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports